module.exports = __webpack_public_path__ + "static/media/AboutSlide_1.0093d3b5.png";